import {Controller} from '@hotwired/stimulus';
import {useIntersection} from 'stimulus-use'
import { hasIntersectionObserver } from '../../js/window-has';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        path: String,
        title: String,
        page: Number
    }

    static targets = ['permutive'];

    connect() {
        if (hasIntersectionObserver()) {
            useIntersection(this)
        }
    }

    appear() {

        if (window.location.pathname !== this.pathValue) {
            document.title = this.titleValue
            history.replaceState(null, '', this.pathValue);

            if (this.hasPermutiveTarget){
                let articleData = null;
                try {
                    articleData = JSON.parse(this.permutiveTarget.innerHTML);
                } catch (e) {
                }

                if (articleData && window.permutive) {
                    articleData.siteVersion= Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768 ? 'mobile' : 'desktop';
                    articleData.userCountryCode = window.navigator.userLanguage || window.navigator.language;
                    window.permutive.addon("web", {page: articleData});
                }
            }


            /*
            *
            if (this.pageValue >= 0) {
                this.analyticsUrl = this.pathValue + '?infinite_scroll=' + (this.pageValue + 1);
            } else {
                this.analyticsUrl = this.pathValue;
            }
            */

            /*
            *
            if (typeof ga !== "undefined") {
                console.log('%c Update anaytics hit: ' + this.analyticsUrl, 'background: #672675; color: #ffffff');

                ga('send', {
                    'hitType': 'pageview',
                    'page': this.analyticsUrl
                });

                ga('reportglobale.send', {
                    'hitType': 'pageview',
                    'page': this.analyticsUrl
                });
            }
            */



        }
    }
}
